<template>
  <div>
    <DisplayContainer label="">
      <v-form
        ref="form"
        v-model="formValid"
        :disabled="!editable"
      >
        <v-container fluid>
          <v-row align="center">
            <v-col
              class="d-flex"
              cols="12"
              sm="6"
            >
              <v-text-field
                :value="constructionPlanningTool"
                label="Verwendetes Bausteuerungstool (readonly)"
                :rules="[v => !!v || 'Dem Projekt ist kein Bausteuerungstool hinterlegt!']"
                required
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="6"
            >
              <DatePicker
                label="Baustart (readonly)"
                :readonly="true"
                :value="constructionStartDate"
                disableWeekend
                disableHolidays
                :errorMessage="dateInputError"
                @input="constructionStartDate = $event"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </DisplayContainer>
    <div class="mb-4 align-buttons-right">
      <v-btn
        :disabled="!editable || !formWithDateValid"
        :loading="isSubmitting"
        color="primary"
        @click="completeTaskDialog = true"
      >
        Tiefbau Freigabe bestätigen
      </v-btn>
    </div>
    <v-dialog
      v-if="editable"
      v-model="completeTaskDialog"
      width="max(20vw, 350px)"
    >
      <v-card>
        <v-card-text class="pt-6">
          <p>
            Mit der Freigabe der Aufgabe geht das Projekt <b>{{ project.projektId }} - {{ project.name }}</b> in den nächsten Projektstatus <b :style="{color: nextStatus.color }">{{ nextStatus.description }}</b>.<br /><br />
            Die Freigabe des Projekts zum Tiefbau hat irreversible Auswirkungen.
            Aus diesem Grund muss die Freigabe noch von einer weiteren Person aus dem <b>Rollout</b> bestätigt werden.
            Sobald das Projekt in die nächste Phase geht, wird:
          </p>
          <ul>
            <li>Eine Homes Passed Freigabe für neue Verträge benötigt</li>
            <li>Der Vertriebsstatus auf “Aktive Nachvermarktung” gesetzt</li>
          </ul>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn
            :disabled="isSubmitting"
            small
            color="secondary"
            class="align-center"
            @click="completeTaskDialog = !completeTaskDialog"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!editable"
            :loading="isSubmitting"
            small
            color="warning"
            class="align-center"
            @click="submitTask"
          >
            Tiefbau Freigabe bestätigen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from '@/components/elements/DatePicker.vue';
import DisplayContainer from '../../components/elements/DisplayContainer.vue';

export default {
  name: 'ActionFreigabeProjektZumTiefbauBereitBestaetigen',
  components: {
    DatePicker,
    DisplayContainer
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    variables: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    isSubmitting: false,
    formValid: false,
    completeTaskDialog: false
  }),
  computed: {
    project() {
      return this.variables.$project;
    },
    constructionPlanningTool() {
      return this.project.constructionManagementTool;
    },
    step() {
      return this.variables.$currentStep;
    },
    expectedStatus() {
      return this.variables.$currentStep.expectedProjectStatus;
    },
    nextStatus() {
      return this.variables.$currentStep.nextProjectStatus;
    },
    constructionStartDate() {
      return this.variables.projectPlanningAndConstructionChangeRequest
        ?.constructionStartDate;
    },
    dateInputError() {
      if (!this.constructionStartDate) {
        return 'Es muss ein Baustart gesetzt werden!';
      }

      return null;
    },
    formWithDateValid() {
      return this.formValid && this.dateInputError === null;
    }
  },
  mounted() {
    this.$refs.form.validate();
  },
  methods: {
    submitTask: function () {
      this.isSubmitting = true;
      this.$parent
        .submitTask({
          newProjectStateDto: this.nextStatus
        })
        .then(() => {
          this.completeTaskDialog = false;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    }
  }
};
</script>
